export const environment = {
  production: true,
  base_server: "https://escritha.com",
  base_url: "https://escritha.com/api/v1",
  auth: "https://escritha.com/login",
  base_href: "escritha-app",
  image_path: "https://escritha.com/media",
  admin_url: "https://escritha.com/escritha-admin",
  pagseguro:
    "https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js",
  socket_url: "https://escritha.com",
  api_convert_bib_url: "https://convert-nbib.onrender.com",
};
